import { getUserProfile } from "../../redux/selectors/profileSelectors";
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-pascal-case */
import { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Table, Input, Avatar, Pagination, Modal } from "antd";
import {
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  LoadingOutlined,
} from "@ant-design/icons";

import "./Myteams.css";
import {
  deleteTeamMember,
  deleteTeamMemberReset,
  getAllTeamMembers,
} from "../../redux/actions";
import Add_Member from "./components/Add Member";
import Edit_Member from "./components/Edit Member";
import MemberPasswordModal from "./components/MemberPasswordModal";
import Loader from "../../components/Loading/Loader";

function getInitial(item) {
  const name = getDisplayName(item);
  return name !== "-" ? name.charAt(0).toUpperCase() : "?";
}

function getDisplayName(item) {
  const firstName = item?.firstName || item?.FirstName || item?.Profiles?.FirstName || "";
  const lastName = item?.lastName || item?.LastName || item?.Profiles?.LastName || "";
  const fullName = item?.fullName || item?.FullName || "";

  return fullName || `${firstName} ${lastName}`.trim() || "-";
}

function getMemberEmail(item) {
  return item?.emailAddress || item?.EmailAddress || item?.email || "-";
}

function getMemberJobTitle(item) {
  return item?.jobTitle || item?.JobTitle || "-";
}

function getMemberPhone(item) {
  return item?.phoneNumber || item?.PhoneNumber || item?.MobileNumber || "-"
}

function getMemberId(item) {
  return item?.invitationId || item?.InvitationId || item?._id || item?.id || item?.accountId;
}

function getDeleteMemberId(item) {
  return item?.invitationId || item?.InvitationId
}

function getRoles(item) {
  const role = item?.Role || item?.role || item?.roles;
  if (!role) return [];
  if (Array.isArray(role)) return role;
  return [role];
}

function getStatusClass(status) {
  const lower = status?.toLowerCase?.() || "";
  if (lower === "active") return "tm-status-active";
  if (lower === "pending") return "tm-status-pending";
  return "tm-status-inactive";
}

function getMemberStatus(item) {
  const rawStatus =
    item?._status ||
    item?.Status ||
    item?.status ||
    item?.TeamMemberStatus ||
    item?.MemberStatus ||
    item?.InvitationStatus ||
    item?.invitationStatus;

  if (rawStatus) {
    const lower = String(rawStatus).toLowerCase();
    if (lower === "active") return "Active";
    if (lower === "pending") return "Pending";
    if (lower === "inactive" || lower === "in-active" || lower === "in active") {
      return "Inactive";
    }
    return String(rawStatus);
  }

  if (item?.isPending === true || item?.IsPending === true) return "Pending";
  if (item?.IsActive === true || item?.isActive === true) return "Active";
  if (item?.IsActive === false || item?.isActive === false) return "Inactive";
  if (item?.isInactive === true || item?.IsInactive === true) return "Inactive";
  if (item?.InvitationId || item?.invitationId) return "Pending";
  return "Active";
}

export default function MyTeams() {
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editMember, setEditMember] = useState(null);
  const [changePasswordMember, setChangePasswordMember] = useState(null);
  const [activateMember, setActivateMember] = useState(null);
  const [deleteMember, setDeleteMember] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const PAGE_SIZE = 10;

  const profile = getUserProfile();
  const isMasterAccount = profile?.MasterAccountId == null;

  const loading = useSelector((state) => state.TeamMembersReducer.loading);
  const teamMembers = useSelector((state) => state.TeamMembersReducer.all);
  const success_ = useSelector((state) => state.TeamMembersReducer.success);
  const deleteMemberLoading = useSelector(
    (state) => state.TeamMembersReducer.deleteMemberLoading
  );
  const deleteMemberSuccess = useSelector(
    (state) => state.TeamMembersReducer.deleteMemberSuccess
  );

  useEffect(() => {
    dispatch(getAllTeamMembers({ search: searchText, page: currentPage, limit: PAGE_SIZE }));
  }, [dispatch, searchText, currentPage, success_]);

  useEffect(() => {
    if (deleteMemberSuccess) {
      setDeleteMember(null);
      dispatch(getAllTeamMembers({ search: searchText, page: currentPage, limit: PAGE_SIZE }));
      dispatch(deleteTeamMemberReset());
    }
  }, [deleteMemberSuccess, dispatch, searchText, currentPage]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchText(searchInput.trim());
      setCurrentPage(1);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchInput]);

  function handleEditClick(item) {
    setEditMember(item);
    setShowEditModal(true);
  }

  function handleChangePasswordClick() {
    setChangePasswordMember(editMember);
    setShowEditModal(false);
  }

  function handleChangePasswordClose() {
    setChangePasswordMember(null);
    setShowEditModal(true);
  }

  function handleActivateClick(item) {
    setActivateMember({
      ...item,
      FullName: getDisplayName(item),
      EmailAddress: getMemberEmail(item),
      JobTitle: getMemberJobTitle(item),
    });
  }

  function handleDeleteClick(item) {
    const deleteId = getDeleteMemberId(item);
    if (!deleteId) return;

    setDeleteMember({
      ...item,
      deleteMemberId: deleteId,
    });
  }

  function handleDeleteConfirm() {
    const memberId = deleteMember?.deleteMemberId;
    if (!memberId) return;

    dispatch(deleteTeamMember(memberId));
  }

  const refreshMembers = useCallback(() => {
    dispatch(getAllTeamMembers({ search: searchText, page: currentPage, limit: PAGE_SIZE }));
  }, [dispatch, searchText, currentPage]);

  const allMembers = teamMembers?.members || [];
  const totalSeats = teamMembers?.totalCount || 0;

  const columns = [
    {
      title: "Member Name",
      key: "memberName",
      render: (_, item) => (
        <div className="tm-member-cell">
          <Avatar className="tm-avatar" size={38}>
            {getInitial(item)}
          </Avatar>
          <div>
            <div className="tm-member-name">{getDisplayName(item)}</div>
            <div className="tm-member-email">{getMemberEmail(item)}</div>
          </div>
        </div>
      ),
    },
    {
      title: "Job Title",
      key: "jobTitle",
      render: (_, item) => (
        <span className="tm-job-title">{getMemberJobTitle(item)}</span>
      ),
    },
    {
      title: "Mobile Number",
      key: "mobile",
      render: (_, item) => (
        <span className="tm-cell-text">{getMemberPhone(item)}</span>
      ),
    },
    {
      title: "Status",
      key: "status",
      render: (_, item) => (
        <span className={`tm-status ${getStatusClass(getMemberStatus(item))}`}>
          {getMemberStatus(item)}
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, item) => {
        const roles = getRoles(item);
        const isAdmin = roles.some((r) => r?.toLowerCase?.() === "admin");
        const isPending = getMemberStatus(item) === "Pending";

        if (getMemberEmail(item)?.toLowerCase?.() === profile?.EmailAddress?.toLowerCase?.()) {
          return null;
        }

        if (isAdmin) {
          return (
            <div className="tm-action-cell">
              <EditOutlined
                className="tm-edit-icon"
                onClick={() => handleEditClick(item)}
              />
            </div>
          );
        }

        if (isPending) {
          return (
            <div className="tm-action-cell">
              <button
                className="tm-activate-btn"
                onClick={() => handleActivateClick(item)}
              >
                Activate
              </button>
            </div>
          );
        }

        return (
          <div className="tm-action-cell">
            <EditOutlined
              className="tm-edit-icon"
              onClick={() => handleEditClick(item)}
            />
            {/* <DeleteOutlined
              className="tm-delete-icon"
              onClick={() => handleDeleteClick(item)}
            /> */}
          </div>
        );
      },
    },
  ];

  const hiddenColumnKeys = isMasterAccount ? [] : ["action"];
  const visibleColumns = columns.filter(
    (column) => !hiddenColumnKeys.includes(column.key)
  );

  return (
    <div className="tm-page">
      {/* Add Member Modal */}
      <Modal
        open={showModal}
        onCancel={() => setShowModal(false)}
        footer={null}
        width={560}
        centered
        className="add-member-modal"
        destroyOnClose
      >
        <Add_Member setShowModal={setShowModal} onSuccess={refreshMembers} />
      </Modal>

      {/* Edit Member Modal */}
      <Modal
        open={showEditModal}
        onCancel={() => setShowEditModal(false)}
        footer={null}
        width={560}
        centered
        className="add-member-modal"
        destroyOnClose
      >
        {editMember && (
          <Edit_Member
            member={editMember}
            setShowEditModal={setShowEditModal}
            onSuccess={refreshMembers}
            onChangePassword={handleChangePasswordClick}
          />
        )}
      </Modal>

      {/* Change Password Modal */}
      <MemberPasswordModal
        open={!!changePasswordMember}
        mode="changePassword"
        member={changePasswordMember}
        onClose={handleChangePasswordClose}
        onSuccess={() => {
          setChangePasswordMember(null);
          setShowEditModal(false);
          refreshMembers();
        }}
      />

      {/* Activate Member Modal */}
      <MemberPasswordModal
        open={!!activateMember}
        mode="activate"
        member={activateMember}
        onClose={() => setActivateMember(null)}
        onSuccess={() => {
          setActivateMember(null);
          refreshMembers();
        }}
      />

      {/* Delete Member Modal */}
      <Modal
        open={!!deleteMember}
        onCancel={() => setDeleteMember(null)}
        footer={null}
        width={400}
        centered
        className="dm-modal"
        destroyOnClose
      >
        <div className="dm-content">
          <div className="dm-icon-wrap">
            <DeleteOutlined />
          </div>
          <h2 className="dm-title">Delete Member</h2>
          <p className="dm-body">Are you sure you want to delete this team member</p>
          <button
            type="button"
            className="dm-delete-btn"
            onClick={handleDeleteConfirm}
            disabled={deleteMemberLoading}
          >
            {deleteMemberLoading ? <LoadingOutlined /> : <DeleteOutlined />}
            {deleteMemberLoading ? "Deleting..." : "Delete Member"}
          </button>
        </div>
      </Modal>

      {/* Page header */}
      <h1 className="tm-title">Team</h1>
      <p className="tm-subtitle">
        Manage your team members.
      </p>

      {/* Main card */}
      <div className="tm-card">
        {/* Toolbar */}
        <div className="tm-toolbar">
          <Input
            className="tm-search"
            prefix={<SearchOutlined style={{ color: "#bbb" }} />}
            placeholder="Search people"
            allowClear
            value={searchInput}
            onChange={(e) => {
              const value = e.target.value;
              setSearchInput(value);
            }}
          />
          {isMasterAccount && (
            <button className="tm-add-btn" onClick={() => setShowModal(true)}>
              <PlusOutlined />
              Add Member
            </button>
          )}
        </div>

        {/* Table */}
        {loading ? (
          <div style={{ padding: "40px 0" }}>
            <Loader />
          </div>
        ) : (
          <Table
            className="tm-table"
            columns={visibleColumns}
            dataSource={allMembers}
            rowKey={(item) => getMemberId(item) || getMemberEmail(item)}
            pagination={false}
            footer={() => (
              <span className="tm-seats-text">{totalSeats} seats used</span>
            )}
          />
        )}

        {/* Pagination */}
        {!loading && totalSeats > PAGE_SIZE && (
          <div className="tm-pagination-wrap">
            <Pagination
              current={currentPage}
              total={totalSeats}
              pageSize={PAGE_SIZE}
              onChange={(page) => setCurrentPage(page)}
              showSizeChanger={false}
            />
          </div>
        )}
      </div>
    </div>
  );
}
